module.exports = __webpack_public_path__ + "img/m-about5.34c35a84.jpeg";